// src/components/LatestNewsSection.jsx
import React, { useState } from 'react';
import Pagination, { autoPerPage } from '../../components/Pagination';
import { publications } from './articles-content';

const LatestNewsSection = () => {
  const [page, setPage] = useState(1);
  // 3 per page on desktop, 2 on tablet (<992), 1 on mobile (<600)
  const perPage = autoPerPage(3, 2, 1);

  const start = (page - 1) * perPage;
  const slice = publications.slice(start, start + perPage);
  const pages = Math.ceil(publications.length / perPage);

  return (
    <section className="section-area section-sp2 bg-gray ov-hidden">
      <div className="container">
        <div className="heading-bx text-center">
          <h2 className="title mb-0">OUR LATEST NEWS</h2>
          <p>Ride N Repair got featured in the following publications.</p>
        </div>

        {/* flex wrapper keeps your slider-item boxes aligned exactly like before */}
        <div
          className="service-slide slick-arrow-none d-flex justify-content-center flex-wrap"
          style={{ margin: '0 -0.5rem' }}
        >
          {slice.map(pub => (
            <div
              key={pub.title}
              className="slider-item"
              style={{
                flex: `0 0 ${100 / perPage}%`,
                maxWidth: `${100 / perPage}%`,
                padding: '0 0.5rem',
              }}
            >
              <div className="blog-card style-1 bg-white shadow">
                <a
                  href={pub.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="post-media"
                >
                  <img src={typeof pub.image === 'object' ? pub.image.default : pub.image} alt={pub.title} />
                </a>
                <div className="post-info">
                  <h5 className="post-title">{pub.title}</h5>
                  {pub.description && (
                    <div className="post-content">
                      <p className="mb-0">{pub.description}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* pagination below */}
        <Pagination page={page} pages={pages} onPage={setPage} />
      </div>
    </section>
  );
};

export default LatestNewsSection;
